<template>
  <span class="tooltip-container">
    <slot name="icon">
      <span class="tooltip-icon" @mouseover="isVisible = true" @mouseleave="isVisible = false">?</span>
    </slot>
    <span v-show="isVisible" class="tooltip-content">
      <template v-if="message">
        {{ message }}
      </template>
      <slot v-else />
    </span>
  </span>
</template>

<script setup>
import { ref } from "vue";

defineProps({
  message: {
    type: String,
  },
});

const isVisible = ref(false);
</script>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip-icon {
  font-weight: bold;
  color: #25294A;
  border-radius: 50%;
  padding: 2px 6px;
  background: #e0e0e0;
  cursor: pointer;
}

.tooltip-content {
  visibility: visible;
  background-color: #ffffff;
  color: #333;
  box-shadow: rgba(37, 41, 74, 0.3411764706) 1px 1px 5px;
  border-radius: 0.375rem;

  text-align: left;
  padding: 0.75rem;
  border-radius: 5px;
  position: absolute;
  z-index: 10;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  width: 250px;
  font-size: 14px;
  line-height: 1.5;
  white-space: normal;
}
</style>